/**
 * @file BookingCTA.tsx
 * @summary Composant global
 *
 * Composant transverse utilisé dans plusieurs pages (header, footer, SEO, layout…).
 *
 * @see docs/07-CODEBASE.md — conventions de code
 * @see docs/02-FRONTEND.md — design system (tokens HSL, typographie)
 */
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

interface BookingCTAProps {
  title?: string;
  className?: string;
}

export default function BookingCTA({
  title = "Envie d'essayer ?",
  className = "",
}: BookingCTAProps) {
  return (
    <section className={`my-12 border border-gold/30 bg-charcoal/40 rounded-lg px-6 py-8 text-center ${className}`}>
      <h2 className="text-2xl md:text-3xl font-heading text-foreground mb-3">{title}</h2>
      <p className="text-foreground/80 mb-6 max-w-xl mx-auto">
        2 séances d'essai gratuites pour découvrir la box, sans engagement.
      </p>
      <div className="flex justify-center">
        <Button size="lg" asChild>
          <Link to="/#contact">Réserver une séance d'essai</Link>
        </Button>
      </div>
    </section>
  );
}
